import * as React from "react";
import { createContext, useState, useContext } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { get_logout_token } from "../core/auth";
import { auth_logout } from "../core/auth";

const ScreenContext = createContext();

export const useScreenContext = () => useContext(ScreenContext);

export const ScreenContextProvider = ({ children }) => {
  const [currentScreen, setCurrentScreen] = useState("/");

  const dispatch = useDispatch();
  const csrf = useSelector((state) => state.csrfTokenReducer);

  const initLogout = () => {
    dispatch({ type: "REMOVE_SESSION" });

    get_logout_token()
      .then((get_logout_token_response) => {
        auth_logout(get_logout_token_response.data.logout_token, csrf)
          .then(() => {
            window.location.href = `${window.location.origin}${window.location.pathname}`;
            setCurrentScreen("/");
          })
          .catch((error) => {
            window.location.href = `${window.location.origin}${window.location.pathname}`;
            setCurrentScreen("/");
          });
      })
      .catch((error) => {
        // clear tokens off the url
        window.location.href = `${window.location.origin}${window.location.pathname}`;
        setCurrentScreen("/");
      });
  };

  return (
    <ScreenContext.Provider value={{ currentScreen, setCurrentScreen, initLogout }}>{children}</ScreenContext.Provider>
  );
};
